import { SET_FILTERS, UPDATE_FILTERS } from 'constants/types';

const INITIAL_STATE = {
  list: []
};

export default function filtersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, list: action.payload };

    case UPDATE_FILTERS:
      return {
        ...state,
        list: action.payload
      };
    default:
      return state;
  }
}
